import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectModeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SelectMode",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.85 31.14c-.31 0-.63-.04-.94-.12a3.49 3.49 0 0 1-2.62-3.42V4.4c0-1.46.84-2.71 2.18-3.27 1.35-.56 2.82-.26 3.85.77l16.34 16.34a3.5 3.5 0 0 1 .56 4.27 3.49 3.49 0 0 1-3.98 1.64l-7.21-1.93c-.52-.14-1.08.09-1.36.56l-3.8 6.58a3.5 3.5 0 0 1-3.04 1.77Zm-.01-28c-.23 0-.42.06-.5.1-.18.08-.77.38-.77 1.15V27.6c0 .89.71 1.15.93 1.21s.96.19 1.41-.58l3.8-6.58c.79-1.37 2.4-2.04 3.93-1.63l7.21 1.93c.86.23 1.29-.39 1.41-.58.11-.2.43-.88-.2-1.51L8.71 3.51c-.29-.29-.6-.37-.86-.37Z"
    })
  }));
};
SelectModeIcon.displayName = 'SelectModeIcon';